import '../styles/About.css'

export default function About(){
    return (
        <>
            <div className='about-out'>
                <h1>About Us</h1>
                <p>
                    An open community based in Dehradun, working in welfare of stray animals. Our main motive is to develop a ecosystem where 
                    anyone who is willing to help a Stray animal can come forward and be a part of this community. We started from a group of 10 people and growing everyday with 
                    a new member connecting locally. There is no head of this Organisation. Everyone is equal, and anyone who is willing to help is always welcomed in the community. We do our best to follow "Seva Parmo dharma" and to remove sufferings and starving.
We have one goal, to reduce animal suffering by addressing the root cause of the issue, lack of human compassion.
                </p>
            </div>

        </>
    )
}